import { Button } from "@/components/ui/button";
import { Card, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { LoadingIndicator } from "@/components/ui/loading-indicator";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import useMusioApi from "@/contexts/client/musio-client-context";
import usePaddle from "@/contexts/paddle/paddle-context";
import type { CheckoutOpenOptions } from "@paddle/paddle-js";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";

const TRIAL_SKU = "MUS-00001";

export const SubscribeCard = () => {
  const [tab, setTab] = useState("annual");
  const paddle = usePaddle();
  const { musioApi } = useMusioApi();

  const monthlyPriceId = import.meta.env.VITE_REACT_APP_PADDLE_MUSIO_PLUS_MONTHLY
  const annualPriceId = import.meta.env.VITE_REACT_APP_PADDLE_MUSIO_PLUS_ANNUAL

  const { data: paddleData } = useQuery({
    queryKey: ["paddle_price_preview"],
    queryFn: async () => {
      return await paddle?.PricePreview({
        items: [
          {
            quantity: 1,
            priceId: monthlyPriceId,
          },
          {
            quantity: 1,
            priceId: annualPriceId,
          },
        ],
        // discountId: import.meta.env.VITE_ANNUAL_40_DISCOUNT,
      });
    },
  });

  const monthlyPrice = paddleData?.data.details.lineItems[0]?.formattedTotals.total!
  // NOTE: remove the formatCurrency line after done with black friday sale and uncomment original
  const annualPrice = paddleData?.data.details.lineItems[1]?.formattedTotals.total!

  const { data: trialData } = musioApi.useQuery("get", "/user/trial");
  const trialAvailable = trialData?.trials.some((t) => t.sku == TRIAL_SKU);

  const { mutate, isPending: isSubscribePending } = musioApi.useMutation("post", "/user/recurring-transaction", {
    onSuccess: (data) => {
      {/* TODO: need to solve 'best coupon' for selected plan based on %-off - include discountId here - post soft-launch*/ }

      // solve FirstPromoter referral
      var promo_code: string | null = null;
      var affiliate_id: string | null = null;
      window.fpr("details", (data) => {
        affiliate_id = data.promoter.id
        promo_code = data.promo_code;
      });

      const settings = {
        allowLogout: false
      }
      let customData = {
        ...(affiliate_id ? {} : { affiliate_id }),
        'checkoutUrl': window.location.href
      };

      let checkoutData: CheckoutOpenOptions = { transactionId: data?.txnId!, settings, customData }
      if (promo_code) {
        if (promo_code?.startsWith("dsc_")) {
          checkoutData.discountId = promo_code;
        } else {
          checkoutData.discountCode = promo_code;
        }
      }

      paddle?.Checkout.open(checkoutData);
    },
  });

  const handleSubscribe = () => {
    mutate({
      body: {
        plan: tab
      }
    });
  };

  return (
    <Card className="relative max-w-[373px] w-full flex flex-col justify-between bg-musio-bg">
      <CardHeader>
        <CardTitle className="text-xl font-medium">
          <Tabs value={tab} onValueChange={setTab} className="w-full">
            <TabsList className="w-full rounded-full">
              <TabsTrigger
                value="monthly"
                className="flex-1 data-[state=active]:bg-musio-green data-[state=active]:text-musio-toggle rounded-full cursor-pointer"
              >
                Monthly
              </TabsTrigger>
              <TabsTrigger
                value="annual"
                className="flex-1 data-[state=active]:bg-musio-green data-[state=active]:text-musio-toggle rounded-full cursor-pointer"
              >
                Annual
              </TabsTrigger>
            </TabsList>

            <p className="text-center mt-2 font-normal text-sm text-lilac">Save 27% with Annual Billing</p>

            <TabsContent value="monthly">
              <div className="pt-6">
              </div>
            </TabsContent>
            <TabsContent value="annual">
              <div className="pt-6">
              </div>
            </TabsContent>
          </Tabs>
        </CardTitle>
      </CardHeader>

      <CardFooter className="flex flex-col gap-2 card-footer-padded">
        <div className="text-center font-bold text-lg text-lilac">
          {trialAvailable && "7-Day Trial, then "}
          {tab === 'monthly' ? (
            monthlyPrice !== undefined ? (
              `${monthlyPrice} / month`
            ) : (
              <LoadingIndicator />
            )
          ) : (
            annualPrice !== undefined ? (
              `${annualPrice}/ year`
            ) : (
              <LoadingIndicator />
            )
          )}
        </div>
        {/* <p className="text-musio-green text-sm">Save 40% on Annual during Black Friday!</p> */}
        {isSubscribePending ?
          <LoadingIndicator /> :
          <Button
            className="w-full bg-musio-blue text-musio-light-lilac hover:text-musio-toggle"
            onClick={handleSubscribe}
          >
            Subscribe
          </Button>
        }
        {/* TODO: need to solve 'best coupon' for selected plan based on %-off - display text here - post soft-launch*/}
      </CardFooter>
    </Card>
  );
};
